import type { FC } from 'react';
import React, { useState } from 'react';

import { plannerItemStatusesConfig } from '@shared/configs/plannerItemStatuses.config';

import { ItemStatusBtn } from './PlannerItemStatusBtn.style';

import type { PlannerItemStatusesEnum } from '@shared/enums/plannerItemStatuses.enum';

export type PlannerItemStatusBtnProps = {
  variant: PlannerItemStatusesEnum;
  isDisabled?: boolean;
  isSelected?: boolean;
  onClick: ({
    status,
    setIsLoading,
  }: {
    status: PlannerItemStatusesEnum;
    setIsLoading?: (val: boolean) => void;
  }) => void;
};

export const PlannerItemStatusBtn: FC<PlannerItemStatusBtnProps> = ({
  isDisabled,
  variant,
  isSelected,
  onClick,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const selectedItem = plannerItemStatusesConfig[variant];
  const handleClick = () => {
    onClick({ status: variant, setIsLoading });
  };
  return (
    <ItemStatusBtn
      size="small"
      fullWidth
      disabled={isDisabled}
      labelColor={selectedItem.color}
      loading={isLoading}
      startIcon={<selectedItem.icon />}
      variant="outlined"
      onClick={handleClick}
      isSelected={isSelected}
      selectedBgColor={selectedItem.selectedBgColor}
      iconColor={selectedItem.iconColor}
    >
      {selectedItem?.label}
    </ItemStatusBtn>
  );
};
